/**
 * AssessmentEmptyState Component
 * Displays empty state when no assessments exist
 * Extracted from Assessments.js for better code organization
 */
import { Card } from '../ui/card';
import { Brain } from 'lucide-react';

const AssessmentEmptyState = () => {
  return (
    <Card className="p-12 text-center" data-testid="assessment-empty-state">
      <Brain size={48} className="mx-auto text-slate-400 mb-4" />
      <p className="text-slate-600 dark:text-slate-400">
        Nenhuma avaliação criada ainda.
      </p>
      <p className="text-sm text-slate-500 mt-2">
        Clique em "Nova Avaliação" para começar.
      </p>
    </Card>
  );
};

export default AssessmentEmptyState;
